export default __webpack_public_path__ + "static/media/cover.959455ef.jpg";